import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import Modal from 'atoms/Modal';
import { ModalProps } from 'atoms/Modal/ModalTypes';
import StyledInfoModal from './StyledInfoModal';
import Button from 'styled/components/Button';
import { modalsActions } from 'features/modals/modalsSlice';

const InfoModal: React.FC<ModalProps> = (props) => {
  const dispatch = useDispatch();

  return (
    <Modal {...props}>
      <StyledInfoModal>
        <div className="info">
          <span className="title">
            <FormattedMessage id="modals.info.title" />
          </span>
          <span className="description">
            <FormattedMessage id="modals.info.description" />
          </span>
        </div>
        <br />
        <div className="content">
          <div className="header">
            <div>
              <FormattedMessage id="modals.info.keyTitle" />
            </div>
            <div>
              <FormattedMessage id="modals.info.keyDescription" />
            </div>
          </div>
          <div className="row">
            <div>H</div>
            <div>
              <FormattedMessage id="modals.info.keyH.Description" />
            </div>
          </div>
          <div className="row">
            <div>B</div>
            <div>
              <FormattedMessage id="modals.info.keyB.Description" />
            </div>
          </div>
          <div className="row">
            <div>F</div>
            <div>
              <FormattedMessage id="modals.info.keyF.Description" />
            </div>
          </div>
          <div className="row">
            <div>N</div>
            <div>
              <FormattedMessage id="modals.info.keyN.Description" />
            </div>
          </div>
          <div className="row">
            <div>P</div>
            <div>
              <FormattedMessage id="modals.info.keyP.Description" />
            </div>
          </div>
          <div className="row">
            <div>V</div>
            <div>
              <FormattedMessage id="modals.info.keyV.Description" />
            </div>
          </div>
          <div className="row">
            <div>I</div>
            <div>
              <FormattedMessage id="modals.info.keyI.Description" />
            </div>
          </div>
        </div>
        <br />
        <div className="info">
          <span className="title">
            <FormattedMessage id="modals.info.autoComplete.title" />
          </span>
          <span className="description">
            <FormattedMessage id="modals.info.autoComplete.description" />
          </span>
        </div>
        <br />
        <div className="content">
          <div className="header">
            <div>
              <FormattedMessage id="modals.info.autoComplete.keyTitle" />
            </div>
            <div>
              <FormattedMessage id="modals.info.autoComplete.keyDescription" />
            </div>
          </div>
          <div className="row">
            <div>:h</div>
            <div>
              <FormattedMessage id="modals.info.autoComplete.h.name" />
            </div>
          </div>
          <div className="row">
            <div>#h</div>
            <div>
              <FormattedMessage id="modals.info.autoComplete.h.number" />
            </div>
          </div>
          <div className="row">
            <div>:a</div>
            <div>
              <FormattedMessage id="modals.info.autoComplete.a.name" />
            </div>
          </div>
          <div className="row">
            <div>#a</div>
            <div>
              <FormattedMessage id="modals.info.autoComplete.a.number" />
            </div>
          </div>
          <div className="row">
            <div>$h</div>
            <div>
              <FormattedMessage id="modals.info.autoComplete.h.manager" />
            </div>
          </div>
          <div className="row">
            <div>$a</div>
            <div>
              <FormattedMessage id="modals.info.autoComplete.a.manager" />
            </div>
          </div>
          <div className="row">
            <div>$s</div>
            <div>
              <FormattedMessage id="modals.info.autoComplete.stadium" />
            </div>
          </div>
          <div className="row">
            <div>$r</div>
            <div>
              <FormattedMessage id="modals.info.autoComplete.referees" />
            </div>
          </div>
        </div>
        <br />
        <div className="actions">
          <Button
            onClick={() => {
              dispatch(modalsActions.setInfoModal(false));
            }}
          >
            <FormattedMessage id="modals.info.close" />
          </Button>
        </div>
      </StyledInfoModal>
    </Modal>
  );
};

export default InfoModal;
